/*
 * This file is part of the Norges Musikkhøyskole Nettsted 2020 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/Modal/Modal';
import ImgixImage from 'components/ImgixImage/ImgixImage';

import styles from './ImageOverlay.module.scss';

/**
 * This is the ImageOverlay component.
 *
 * @author Anders Stalheim Øfsdahl <anders@apt.no>
 *
 * @return {JSX}
 */
function ImageOverlay({ visible, item, onClose }) {
  return (
    <Modal visible={visible} onClose={onClose}>
      <div className={styles.wrapper}>
        {item && (
          <ImgixImage {...item} eager onClick={onClose} sizes={['97vw']} />
        )}
      </div>
    </Modal>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
ImageOverlay.propTypes = {
  visible: PropTypes.bool,
  item: PropTypes.oneOfType([PropTypes.shape, PropTypes.bool]),
  onClose: PropTypes.func,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
ImageOverlay.defaultProps = {
  visible: false,
  item: false,
  onClose: () => {},
};

export default ImageOverlay;
